import { Lock, type LucideIcon } from "lucide-react";

type Props = {
  icon: LucideIcon;
  label: string;
  /** Rótulo curto pro mobile, onde ele fica na mesma linha do valor ("Laboratório" → "Lab").
   *  Sem isso, cai no `label` completo. */
  shortLabel?: string;
  value: string;
};

/** Caixa de confirmação só-leitura — o que já foi escolhido numa etapa anterior (organização,
 *  paciente, laboratório).
 *
 *  Empilhada no mobile as três custavam 198px, 30% da tela, empurrando o odontograma pra fora da
 *  dobra. Aqui o mobile perde o quadrado do ícone e põe rótulo e valor na mesma linha; o desktop
 *  segue igual ao que sempre foi. O valor nunca é encurtado além do `truncate` natural: são nomes
 *  de paciente e laboratório, conferidos antes de enviar o pedido. */
export function LockedInfoBox({ icon: Icon, label, shortLabel, value }: Props) {
  return (
    <div className="flex items-center gap-2 rounded-lg border border-zinc-200 bg-zinc-50/60 px-2.5 py-1.5 dark:border-border dark:bg-muted/30 sm:gap-2.5 sm:px-3 sm:py-2">
      <span className="hidden h-8 w-8 shrink-0 items-center justify-center rounded-md bg-brand-100 text-brand-700 dark:bg-primary/15 dark:text-primary sm:flex">
        <Icon className="h-4 w-4" />
      </span>
      <div className="flex min-w-0 flex-1 items-center gap-2 sm:block sm:gap-0">
        <p className="shrink-0 text-[9px] font-bold uppercase tracking-wider text-zinc-500 dark:text-muted-foreground sm:text-xs sm:font-semibold">
          <span className="sm:hidden">{shortLabel ?? label}</span>
          <span className="hidden sm:inline">{label}</span>
        </p>
        <p className="truncate text-[12.5px] font-semibold text-zinc-900 dark:text-foreground sm:text-base">
          {value}
        </p>
      </div>
      <Lock className="h-3 w-3 shrink-0 text-zinc-300 dark:text-muted-foreground/60 sm:h-3.5 sm:w-3.5" />
    </div>
  );
}
